<div class="encabezado">
  <div class="col-4 getBack "> <a routerLink="/settings" class="getBack"> <span><i class="icon-chevron-left"></i>{{ "forms.buttons.back" | translate }} </span></a></div>
  <div>
    <div>
      <div>
        <h5 class="titulo1">{{ "titles-menu-pages." + title | translate }}</h5>
      </div>
    </div>
  </div>
  <div class="">
    <div class="">
      <div class="row">
        <div class="col-12">
          <div class="btn-izq">
            <button class="btn btn-hover" type="button" (click)="toggleForm()">
              {{ "buttons.add+" | translate }} <i class="icon-plus"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="tabla">
      <div class="table-responsive-wrapper">
      <div class="table-scroll-inner">
      <table mat-table class="full-width-table" matSort aria-label="Brands" multiTemplateDataRows
        [dataSource]="dataSource">

        <!-- serial Column -->
        <ng-container matColumnDef="reference">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.reference" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row?.reference">
              {{ row?.reference }}
            </span>
          </td>
        </ng-container>

        <!-- name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.name" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row?.name">
              {{ row?.name }}
            </span>
          </td>
        </ng-container>

        <!-- lastname Column -->
        <ng-container matColumnDef="lastname">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.lastname" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row?.lastname">
              {{ row?.lastname }}
            </span>

          </td>
        </ng-container>

        <!-- roles Column -->
        <ng-container matColumnDef="roles">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.roles" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">

            <div class="column-list">
              <span *ngIf="row?.roles">
                {{ "inputs."+ row?.roles | translate }}
              </span>
              <span *ngIf="! row?.roles">
                {{ "inputs.norole" | translate }}
              </span>
            </div>
          </td>
        </ng-container>

        <!-- email Column -->
        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.email" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row?.email">
              {{ row?.email }}
            </span>
          </td>
        </ng-container>


        <!-- phone Column -->
        <ng-container matColumnDef="phone">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.phone" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row?.phone">
              {{ row?.phone }}
            </span>
          </td>
        </ng-container>


        <!-- img Column -->
        <ng-container matColumnDef="img">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.img" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">

            <img *ngIf="row?.img" class="img-list-users" src="{{row?.img}}" alt="" height="22" />
          </td>
        </ng-container>

        <!-- status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.status" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="row?.status" class="badge text-badge-list"
              [ngClass]="getBadgeColor('active' ,row.require_action,row.priority)">{{
              "badge-status_select-stage.active" | translate
              }}</span>
               <span *ngIf="!row?.status" class="badge text-badge-list"
               [ngClass]="getBadgeColor('inactive' ,row.require_action,row.priority)">{{
               "badge-status_select-stage.inactive" | translate
               }}</span>
          </td>
        </ng-container>

        <!-- actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="cabecera-tabla">
            {{ "inputs.actions" | translate }}
          </th>
          <td mat-cell *matCellDef="let row">
            <i class="icon-pencil text-success icon-actions" (click)="getUser(row.reference)" aria-hidden="true"></i>
            <i *ngIf="row.reference !== authenticatedUserReference" class="icon-trash text-success icon-actions" (click)="deleteUser(row.reference)" aria-hidden="true"></i>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="toggleRow(row)"
          [ngClass]="{'tr-selected': expandedRow?.reference === row.reference}"></tr>
        <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr> -->

      </table>
      </div>
      </div>
      <!-- Card layout mobile -->
      <div class="cards-mobile-wrapper">
        <div *ngFor="let row of dataSource.data" class="settings-card" (click)="getUser($any(row).reference)">
          <div class="card-header-row">
            <span class="card-name">{{ $any(row).name }} {{ $any(row).lastname }}</span>
            <span *ngIf="$any(row).status" class="badge text-badge-list"
              [ngClass]="getBadgeColor('active', $any(row).require_action, $any(row).priority)">
              {{ "badge-status_select-stage.active" | translate }}
            </span>
            <span *ngIf="!$any(row).status" class="badge text-badge-list"
              [ngClass]="getBadgeColor('inactive', $any(row).require_action, $any(row).priority)">
              {{ "badge-status_select-stage.inactive" | translate }}
            </span>
          </div>
          <div class="card-body-content">
            <span class="card-detail"><i class="icon-user"></i> {{ "inputs." + $any(row).roles | translate }}</span>
            <span *ngIf="$any(row).email" class="card-detail"><i class="icon-envelope"></i> {{ $any(row).email }}</span>
            <span *ngIf="$any(row).phone" class="card-detail"><i class="icon-phone"></i> {{ $any(row).phone }}</span>
          </div>
          <div class="card-footer-row">
            <div class="card-actions">
              <i class="icon-pencil text-success icon-actions" (click)="getUser($any(row).reference); $event.stopPropagation()"></i>
              <i *ngIf="$any(row).reference !== authenticatedUserReference" class="icon-trash text-danger icon-actions" (click)="deleteUser($any(row).reference); $event.stopPropagation()"></i>
            </div>
          </div>
        </div>
      </div>

      <mat-paginator [length]="paginator.length" [pageSize]="pageSize" [pageSizeOptions]="[25, 50, 100]" (page)="onPageChange($event)">
      </mat-paginator>
    </div>


  </div>

  <div class="formulario-derecha-container" [ngClass]="{ 'mostrar-formulario': showForm }">
    <app-form-add-users *ngIf="showForm" [userData]="userData" [isSelfEdit]="isSelfEdit" (backButtonClick)="cerrarFormulario()"
      (addUser)="refrescar()"></app-form-add-users>
  </div>


  <div class="overlay" *ngIf="showForm" (click)="cerrarFormulario()"></div>
</div>
